<template>
<div class="chapter">
<div class="inner_page">
<p style="text-align:center; margin-top:3pc"></p>
<p class="dedication"><a id="dedi"></a><i>Dedicated to</i></p>
<p class="dedication1"><i>Deb, Chief Nag-ivator Extraordinaire, for more reasons than I can possibly list</i>,</p>
<p class="dedication"><i>and</i></p>
<p class="dedication1"><i>Caro, who went out of her way to keep the Feline Manager happy with brushies, not to mention being an Errand Angel who went so far as to cook actual food in order to see to the care and feeding of a desperate writer when schedules got tight</i>,</p>
<p class="dedication"><i>and of course</i>,</p>
<p class="dedication1"><i>Tinkerbell, Supreme Royal Feline Manager, whose careful supervision of writing sessions was an invaluable source of inspiration and encouragement, plus—just in case—thanks, Mom!</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03dedication.vue?1b89ad31